<template>
    <div v-if="page_loading">
        <loading :page_loading="page_loading" />
    </div>
    <div v-else>
      <loading :loading="loading" />
        <v-card elevation="1" class="v-card-bottom-30 hidden-xs-only">
          <v-card-title  style="height: 60px;">
            <h4>{{use_language.report}}</h4><v-icon>mdi-chevron-right</v-icon><span class="font-weight-regular body-1">{{use_language.report_cod}}</span>
          </v-card-title>
        </v-card>
        <v-card  class="v-card-bottom-30">
          <v-card-text>
            <v-row class="overflow-x-auto mt-0" v-if="isSearching != null">
              <v-col class="pt-0 px-0" cols="12">
                <v-tabs v-model="tabSelect">
                  <v-tab @click="changeTab(1)">{{use_language.grouped_by_date_cod}}</v-tab>
                  <v-tab @click="changeTab(2)">{{use_language.group_by_delivery_date}}</v-tab>
                </v-tabs>
              </v-col>
              <v-col class="pt-0 px-0" cols="12" v-if="this.tab == 1">
                <v-row class="mt-0 px-0 mx-0 pb-1" style="background: #fff;">
                  <v-col cols="12" md="3" lg="3" >
                    <v-menu
                      ref="menu_search_tranferred_date_from"
                      v-model="menu_search_tranferred_date_from"
                      :close-on-content-click="false"
                      :return-value.sync="transferred_date_from"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computed_search_tranferred_date_from"
                          @change="value => computed_search_tranferred_date_from = value"
                          autocomplete="off"
                          :label="use_language.start_"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          v-on="on"
                        >
                          <template v-slot:label> <span>{{use_language.start}}</span> </template> 
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="transferred_date_from" @input="menu_search_tranferred_date_from = false, $refs.menu_search_tranferred_date_from.save(transferred_date_from)" no-title :allowed-dates="allowedDates" class="my-0">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" lg="3" >
                    <v-menu
                      ref="menu_search_tranferred_date_to"
                      v-model="menu_search_tranferred_date_to"
                      :close-on-content-click="false"
                      :return-value.sync="transferred_date_to"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computed_search_tranferred_date_to"
                          @change="value => computed_search_tranferred_date_to = value"
                          autocomplete="off"
                          :label="use_language.end"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          v-on="on"
                        >
                         <template v-slot:label> <span>{{use_language.end}}</span> </template> 
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="transferred_date_to" @input="menu_search_tranferred_date_to = false, $refs.menu_search_tranferred_date_to.save(transferred_date_to)" no-title :allowed-dates="allowedDates" class="my-0">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" lg="3" class="pb-0" align="center">
                    <v-btn @click="get_data_tab1()" color="primary" class="mr-3">{{use_language.search}}</v-btn>
                    <v-btn @click="SearchingClearData()" outlined color="primary" class="mr-3">{{use_language.reset}}</v-btn>
                  </v-col>
                </v-row>
                <v-row class="mt-0 mx-0 px-0">
                  <!-- ค้นหา 1 -->
                  <v-col cols="12">
                    <v-data-table :headers="headers1" :items="showdataTable1" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                      <template v-slot:item.logoPicSmall="{ item }">
                        <div align="center">
                          <v-img style="margin:5px;"
                            :src="item.logoPicSmall"
                            max-width="50"
                        ></v-img>
                        </div>
                      </template>
                      <template v-slot:item.realTransferDatetime="{ item }">
                       
                        {{ formatDatetime(item.realTransferDatetime) }}
                       
                      </template>
                      <template v-slot:item.codAmount="{ item }">
                        {{ format_price(item.codAmount) }}
                      </template>
                      <template v-slot:item.showDetail="{ item }">
                        <span href="#" @click="get_detail_report(1,item)"><v-icon color="primary">mdi-tooltip-text</v-icon></span>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="pt-0 px-0" cols="12" v-else-if="this.tab == 2">
                <v-row class="mt-0 px-0 mx-0 pb-1" style="background: #fff;">
                  <v-col cols="12" md="3" lg="3" class="pb-0">
                  <!-- ค้นหา 2 -->
                    <v-menu
                      ref="menu_search_sent_date_from"
                      v-model="menu_search_sent_date_from"
                      :close-on-content-click="false"
                      :return-value.sync="sent_date_from"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computed_search_sent_date_from"
                          @change="value => computed_search_sent_date_from = value"
                          autocomplete="off"
                          :label="use_language.start_"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="sent_date_from" @input="menu_search_sent_date_from = false, $refs.menu_search_sent_date_from.save(sent_date_from)" no-title :allowed-dates="allowedDates" class="my-0">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" lg="3" >
                    <v-menu
                      ref="menu_search_sent_date_to"
                      v-model="menu_search_sent_date_to"
                      :close-on-content-click="false"
                      :return-value.sync="sent_date_to"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computed_search_sent_date_to"
                          @change="value => computed_search_sent_date_to = value"
                          autocomplete="off"
                          :label="use_language.end"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="sent_date_to" @input="menu_search_sent_date_to = false, $refs.menu_search_sent_date_to.save(sent_date_to)" no-title :allowed-dates="allowedDates" class="my-0">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" lg="3" class="pb-0" align="center">
                    <v-btn @click="get_data_tab2()" color="primary" class="mr-3">{{use_language.search}}</v-btn>
                    <v-btn @click="SearchingClearData()" outlined color="primary" class="mr-3">{{use_language.reset}}</v-btn>
                  </v-col>
                </v-row>
                <v-row class="mx-0 px-0">
                  <v-col cols="12">
                    <v-data-table :headers="headers2" :items="showdataTable2" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                      <template v-slot:item.logoPicSmall="{ item }">
                        <div align="center">
                          <v-img style="margin:5px;"
                            :src="item.logoPicSmall"
                            max-width="50"
                        ></v-img>
                        </div>
                      </template>
                      <template v-slot:item.sendToExpressDatetime="{ item }">
                       
                       {{ formatDatetime(item.sendToExpressDatetime).substr(0,10) }}
                      
                     </template>
                      <template v-slot:item.sumTotal="{ item }">
                        {{ format_price(item.sumTotal) }}
                      </template>
                      <template v-slot:item.sumWaitTransfer="{ item }">
                        {{ format_price(item.sumWaitTransfer) }}
                      </template>
                      <template v-slot:item.sumTransfered="{ item }">
                        {{ format_price(item.sumTransfered) }}
                      </template>
                      <template v-slot:item.showDetail="{ item }">
                        <span href="#" @click="get_detail_report(2,item)"><v-icon color="primary">mdi-tooltip-text</v-icon></span>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-dialog v-model="dialog_detail" scrollable persistent width="auto" >
          <v-card  class="my-0">
            <v-card-title>
              <span class="headline">{{use_language.list_order}}</span>
              <vue-excel-xlsx
                  :data="tab_data_detail_all_status"
                  :columns="excel_order_header"
                   v-bind:filename='use_language.order_data_report'
                  :file-name="use_language.report_cod"
                  sheetname="shee1"
                  >
                <v-icon color="success" class="ml-5">mdi-file-excel</v-icon>
              </vue-excel-xlsx>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog_detail = false">
                <v-icon color="danger">mdi-close</v-icon>
              </v-btn>
            
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-row >
                <v-col cols="12">
                  <v-tabs v-model="detail_tabSelect">
                    <v-tab @click="detail_changeTab(1)">{{use_language.successful_delivery}} {{ use_language.transferred }} {{ this.tab_data_detail_success.length }} {{use_language.item}}</v-tab>
                    <v-tab @click="detail_changeTab(2)">{{use_language.successful_delivery}} {{ use_language.waiting_for_transfer }} {{ this.tab_data_detail_success_wait_transfer.length }} {{use_language.item}}</v-tab>
                    <v-tab @click="detail_changeTab(3)">{{use_language.during_delivery}} {{ this.tab_data_detail_sending.length }}  {{use_language.item}}</v-tab>
                    <v-tab @click="detail_changeTab(4)">{{use_language.bounce}} {{ this.tab_data_detail_return.length }}  {{use_language.item}}</v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
              <v-row v-show="this.detail_tab == 1" style="height: 600px;">
                <v-col cols="12" >
                  <v-data-table :headers="headers_detail" :items="tab_data_detail_success" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                    <template v-slot:item.orderMasterID="{ item }">
                      <a href="#" class="text-info" @click="detail_page(item)"> {{  item.orderMasterID_show  }}</a>
                    </template>
                    <template v-slot:item.fullBankName="{ item }">
                      {{ item.fullBankName }}
                    </template>
                    <template v-slot:item.createdDatetime="{ item }">
                       {{ formatDatetime(item.createdDatetime)}}
                     </template>
                     <template v-slot:item.sendToExpressDatetime="{ item }">
                       {{ formatDatetime(item.sendToExpressDatetime) }}
                     </template>
                     <template v-slot:item.realTransferDatetime="{ item }">
                       {{ formatDatetime(item.realTransferDatetime)}}
                     </template>
                     <template v-slot:item.parcelSuccessDateTime="{ item }">
                       {{ formatDatetime(item.parcelSuccessDateTime) }}
                     </template>
                    <template v-slot:item.codAmount="{ item }">
                      {{ format_price(item.codAmount) }}
                    </template>
                  
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row v-show="this.detail_tab == 2" style="height: 600px;">
                <v-col cols="12" >
                  <v-data-table :headers="headers_detail" :items="tab_data_detail_success_wait_transfer" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                    <template v-slot:item.orderMasterID="{ item }">
                      <a href="#" class="text-info" @click="detail_page(item)"> {{  item.orderMasterID_show  }}</a>
                    </template>
                    <template v-slot:item.fullBankName="{ item }">
                      {{ item.fullBankName }}
                    </template>
                    <template v-slot:item.createdDatetime="{ item }">
                       {{ formatDatetime(item.createdDatetime)}}
                     </template>
                     <template v-slot:item.sendToExpressDatetime="{ item }">
                       {{ formatDatetime(item.sendToExpressDatetime) }}
                     </template>
                 
                     <template v-slot:item.parcelSuccessDateTime="{ item }">
                       {{ formatDatetime(item.parcelSuccessDateTime) }}
                     </template>
                    <template v-slot:item.codAmount="{ item }">
                      {{ format_price(item.codAmount) }}
                    </template>
                  
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row v-show="this.detail_tab == 3" style="height: 600px;">
                <v-col cols="12" >
                  <v-data-table :headers="headers_detail" :items="tab_data_detail_sending" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                    <template v-slot:item.orderMasterID="{ item }">
                      <a href="#" class="text-info" @click="detail_page(item)">{{  item.orderMasterID_show  }}</a>
                    </template>
                    <template v-slot:item.createdDatetime="{ item }">
                       {{ formatDatetime(item.createdDatetime)}}
                     </template>
                     <template v-slot:item.sendToExpressDatetime="{ item }">
                       {{ formatDatetime(item.sendToExpressDatetime) }}
                     </template>
                    <template v-slot:item.fullBankName="{ item }">
                      {{ item.fullBankName }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row v-show="this.detail_tab == 4" style="height: 600px;">
                <v-col cols="12" >
                  <v-data-table :headers="headers_detail" :items="tab_data_detail_return" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                    <template v-slot:item.orderMasterID="{ item }">
                      <a href="#" class="text-info" @click="detail_page(item)">{{  item.orderMasterID_show  }}</a>
                    </template>
                    <template v-slot:item.createdDatetime="{ item }">
                       {{ formatDatetime(item.createdDatetime)}}
                     </template>
                     <template v-slot:item.sendToExpressDatetime="{ item }">
                       {{ formatDatetime(item.sendToExpressDatetime) }}
                     </template>
                     <template v-slot:item.returnedDateTime="{ item }">
                       {{ formatDatetime(item.returnedDateTime) }}
                     </template>
                    <template v-slot:item.fullBankName="{ item }">
                      {{ item.fullBankName }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions >
              <v-row align="center" justify="center" class="mx-0">
               

               
                <v-col cols="12" align="center" justify="center">
                  <div v-if="this.detail_tab == 1">
                    
                      {{use_language.total_cod_all}}<span class="text-success"> {{ format_price(this.sum_transfer) }} </span> {{use_language.bath}}
                   
                  </div>
                  <div v-if="this.detail_tab == 2">
                    {{use_language.total_cod_all}} {{ format_price(this.sum_wait_transfer) }} {{use_language.bath}}
                  </div>
                  <div v-if="this.detail_tab == 3">
                    {{use_language.total_cod_all}} {{ format_price(this.sum_on_delivery) }} {{use_language.bath}}
                  </div>
                  <div v-if="this.detail_tab == 4">
                    {{use_language.total_cod_all}} {{ format_price(this.sum_return) }} {{use_language.bath}}
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Loading from '@/website/components/Loading'
    import axios from 'axios'
    import { reportService_dotnet } from '@/website/global'
    import { format_number, format_order_id, format_price,get_languages,formatDatetime } from '@/website/global_function'
    import { token_api, header_token } from '@/website/backend/token'
   

   
   export default {
        components: {
            Loading
        },

        data: () => ({
            page_loading: true,
            loading: false,
            use_language: null,
            set_language: null,

            isSearching: null,
            menu_search_tranferred_date_from: false,
            transferred_date_from: null,
            menu_search_tranferred_date_to: false,
            transferred_date_to: null,
            menu_search_sent_date_from: false,
            sent_date_from: null,
            menu_search_sent_date_to: false,
            sent_date_to: null,
            sum_transfer:0,
            sum_wait_transfer:0,
            sum_on_delivery:0,
            sum_return:0,

            tabSelect: 0,
            tab: 1,
            showdataTable: [],
            showdataTable1: [],
            showdataTable2: [],
            showdataTable3: [],
            tab_data_detail_success: [],
            tab_data_detail_success_wait_transfer: [],
            tab_data_detail_sending: [],
            tab_data_detail_return: [],
            tab_data_detail_all_status: [],

            detail_tabSelect:0,
            detail_tab:1,

            dialog_detail: false,
            dialog_detail_Sum_COD: 0,

            headers_detail: [],
        }),

        computed: {
          computed_search_sent_date_from() {
            return this.formatDates(this.sent_date_from)
          },

          computed_search_sent_date_to() {
            return this.formatDates(this.sent_date_to)
          },

          computed_search_tranferred_date_from() {
            return this.formatDates(this.transferred_date_from)
          },

          computed_search_tranferred_date_to() {
            return this.formatDates(this.transferred_date_to)
          },

          headers1() {
            return [
              { text: this.use_language.date_of_deposit, align: 'left', sortable: false, value: 'realTransferDatetime' },
              { text: this.use_language.transport, align: 'center', value: 'logoPicSmall', sortable: false },
              { text: this.use_language.in_account, align: 'left', value: 'bankAccount', sortable: false },
              { text: this.use_language.total, align: 'right', value: 'codAmount', sortable: false },
              { text: this.use_language.number_parcels, align: 'center', value: 'sumOrder', sortable: false },
              { text: this.use_language.details, align: 'center', value: 'showDetail', sortable: false },
            ]
          },

          headers2() {
            return [
              { text: this.use_language.date_sent, align: 'left', value: 'sendToExpressDatetime', sortable: false },
              { text: this.use_language.transport, align: 'center', value: 'logoPicSmall', sortable: false },
              { text: this.use_language.during_delivery, align: 'center', value: 'countOnTheWay', sortable: false },
              { text: this.use_language.bounce, align: 'center', value: 'countReturn', sortable: false },
              { text: this.use_language.sent_success, align: 'center', value: 'countSuccess', sortable: false },
              { text: this.use_language.percent_success, align: 'right', value: 'percentSent', sortable: false },
              { text: this.use_language.cod_all, align: 'right', value: 'sumTotal', sortable: false },
              { text: this.use_language.waiting_for_transfer, align: 'right', value: 'sumWaitTransfer', sortable: false },
              { text: this.use_language.cod_transferred, align: 'right', value: 'sumTransfered', sortable: false },
              { text: this.use_language.details, align: 'center', value: 'showDetail', sortable: false },
            ]
          },

          headers_detail_success() {
            return [
              { text: 'OrderID', align: 'center', sortable: false, value: 'orderMasterID' },
              { text: this.use_language.create_date, align: 'left', value: 'createdDatetime', sortable: false },
              { text: this.use_language.date_sent, align: 'left', value: 'sendToExpressDatetime', sortable: false },
              { text: 'TrackingNo', align: 'center', value: 'trackingNo', sortable: false },
              { text: this.use_language.receiver_name, align: 'left', value: 'receiverName', sortable: false },
              { text: this.use_language.order_tab_count_success, align: 'left', value: 'parcelSuccessDateTime', sortable: false },
              { text: 'COD', align: 'right', value: 'codAmount', sortable: false },
              { text: this.use_language.in_account, align: 'left', value: 'fullBankName', sortable: false },
              { text: this.use_language.date_of_deposit, align: 'left', value: 'realTransferDatetime', sortable: false },
              { text: this.use_language.create_by, align: 'center', value: 'createdByStaffShopName', sortable: false },
              { text: this.use_language.salesperson, align: 'center', value: 'salemanName', sortable: false },
            ]
          },

          headers_detail_success_wait_transfer() {
            return [
              { text: 'OrderID', align: 'center', sortable: false, value: 'orderMasterID' },
              { text: this.use_language.create_date, align: 'left', value: 'createdDatetime', sortable: false },
              { text: this.use_language.date_sent, align: 'left', value: 'sendToExpressDatetime', sortable: false },
              { text: 'TrackingNo', align: 'center', value: 'trackingNo', sortable: false },
              { text: this.use_language.receiver_name, align: 'left', value: 'receiverName', sortable: false },
              { text: this.use_language.order_tab_count_success, align: 'left', value: 'parcelSuccessDateTime', sortable: false },
              { text: 'COD', align: 'right', value: 'codAmount', sortable: false },
              { text: this.use_language.create_by, align: 'center', value: 'createdByStaffShopName', sortable: false },
              { text: this.use_language.salesperson, align: 'center', value: 'salemanName', sortable: false },
            ]
          },

          headers_detail_sending() {
            return [
              { text: 'OrderID', align: 'center', sortable: false, value: 'orderMasterID' },
              { text: this.use_language.create_date, align: 'left', value: 'createdDatetime', sortable: false },
              { text: this.use_language.date_sent, align: 'left', value: 'sendToExpressDatetime', sortable: false },
              { text: 'TrackingNo', align: 'center', value: 'trackingNo', sortable: false },
              { text: this.use_language.receiver_name, align: 'left', value: 'receiverName', sortable: false },
              { text: 'COD', align: 'right', value: 'codAmount', sortable: false },
              { text: this.use_language.create_by, align: 'center', value: 'createdByStaffShopName', sortable: false },
              { text: this.use_language.salesperson, align: 'center', value: 'salemanName', sortable: false },
            ]
          },

          headers_detail_return() {
            return [
              { text: 'OrderID', align: 'center', sortable: false, value: 'orderMasterID' },
              { text: this.use_language.create_date, align: 'left', value: 'createdDatetime', sortable: false },
              { text: this.use_language.date_sent, align: 'left', value: 'sendToExpressDatetime', sortable: false },
              { text: 'TrackingNo', align: 'center', value: 'trackingNo', sortable: false },
              { text: this.use_language.receiver_name, align: 'left', value: 'receiverName', sortable: false },
              { text: 'COD', align: 'right', value: 'codAmount', sortable: false },
              { text: this.use_language.bounce_date, align: 'left', value: 'returnedDateTime', sortable: false },
              { text: this.use_language.create_by, align: 'center', value: 'createdByStaffShopName', sortable: false },
              { text: this.use_language.salesperson, align: 'center', value: 'salemanName', sortable: false },
            ]
          },

          excel_order_header() {
            return [
              { label: this.use_language.order_number, field: 'orderMasterID_show'},
              { label: this.use_language.create_date,  field: 'createdDatetime' },
              { label: this.use_language.date_sent,  field:'sendToExpressDatetime' },
              { label: this.use_language.parcel_delivery_status,  field:'parcelStatusName' },
              { label: 'TrackingNo',  field: 'trackingNo' },
              { label: this.use_language.receiver_name,  field: 'receiverName' },
              { label: this.use_language.order_tab_count_success, field: 'parcelSuccessDateTime' },
              { label: 'COD', align: 'right', field: 'codAmount' },
              { label: this.use_language.in_account, field: 'fullBankName' },
              { label: this.use_language.date_of_deposit, field: 'realTransferDatetime' },
              { label: this.use_language.create_by, field: 'createdByStaffShopName' },
              { label: this.use_language.salesperson, field: 'salemanName' },
              { label: this.use_language.bounce_date, field: 'returnedDateTime' },
            ]
          },

        },

        async created() {
          var currentDate = new Date();
         
          
          this.transferred_date_to = new Date();
          this.transferred_date_from = new Date(currentDate.getFullYear(),currentDate.getMonth() ,1);
          this.transferred_date_to=currentDate.getFullYear()+"-"+(currentDate.getMonth() +1)+"-"+currentDate.getDate();
          this.transferred_date_from=currentDate.getFullYear()+"-"+(currentDate.getMonth() +1)+"-01";
          this.sent_date_to =currentDate.getFullYear()+"-"+(currentDate.getMonth() +1)+"-"+currentDate.getDate();
          this.sent_date_from=currentDate.getFullYear()+"-"+(currentDate.getMonth() +1)+"-01";

           //เก็บภาษามาไว้ใน use_language
         this.use_language = await this.get_languages(localStorage.getItem("set_language"));



            this.shop_id = localStorage.getItem("shop_id")
            this.staff_id = localStorage.getItem("staff_id")
            await this.changeTab(this.tab)
            await this.get_data_tab1()
            this.page_loading = false
            await this.get_data_tab2()
        },

        methods: {
          formatDatetime,
          format_number,
          format_order_id,
          format_price,
          get_languages,
          allowedDates: val => val <= new Date().toISOString().substr(0, 10),

          formatDates (date) {
            if (date == null){
              return null
            } else {
              const [year, month, day] = date.split('-')
              return `${day}-${month}-${year}`
            }
          },

          detail_page (item) {
            window.open('order-detail?id='+item.orderMasterID+'&token='+item.token, '_blank');
          },

          FormatOrder(orderid){
            if(orderid==null)
              return ""
            var returnString=""
            var len = orderid.toString().length
            if(len<6){

               for (var i = len; i <= 5; i++) {
                 returnString=returnString+"0"
               }
            }
            returnString=returnString+orderid.toString()
            return returnString
          },

          changeTab (tab) {
            if (tab == 1){
              this.tabSelect = 0
            }else if(tab == 2) {
              this.tabSelect = 1
            }
            this.tab = tab
          },

          async get_data_tab1(){
        
            
            this.isSearching = false
            this.loading = true
            let response = await axios.post(reportService_dotnet+'Report/get-cod-report-group-by-realtransferdatetime', {
              "shopID": localStorage.getItem('shop_id'),
              "startDate": this.transferred_date_from ,
              "endDate": this.transferred_date_to 
            }, {headers: header_token})
              this.loading = false
              this.showdataTable1 = []
              this.showdataTable1 = response.data.data_list
              this.transferred_date_from = response.data.start_date
              this.transferred_date_to = response.data.end_date
          },

          async get_data_tab2(){
            this.isSearching = false
            this.loading = true
            let response = await axios.post(reportService_dotnet+'Report/get-cod-report-group-by-sendtoexpressdatetime', {
              "shopID": localStorage.getItem('shop_id'),
              "startDate": this.sent_date_from,
              "endDate": this.sent_date_to
            }, {headers: header_token})
              this.loading = false
              this.showdataTable2 = []
              this.showdataTable2 = response.data.data_list
              this.sent_date_from = response.data.start_date
              this.sent_date_to = response.data.end_date
          },

          async get_detail_report(type, item){
            this.loading = true
            this.changeTab(this.tab)
            this.detail_changeTab(1)
            var date_tmp ;
            if(type == 1){
              date_tmp = item.realTransferDatetime;
              this.dialog_detail_Sum_COD = item.codAmount
            }else {
              date_tmp = item.sendToExpressDatetime;
              this.dialog_detail_Sum_COD = item.sumTotal
            }

            let response = await axios.post(reportService_dotnet+'Report/get-detail-cod-report-group-by', {
              "shopID": localStorage.getItem('shop_id'),
              "type": type,
              "date_time": item.dateKey
            }, {headers: header_token})
              this.loading = false
              this.tab_data_detail_succes = []
              this.tab_data_detail_sending = []
              this.tab_data_detail_return = []
              this.tab_data_detail_all_status = []
              this.tab_data_detail_success = response.data.data_success
              this.tab_data_detail_success_wait_transfer = response.data.data_success_wait_transfer
              this.tab_data_detail_sending = response.data.data_onTheWay
              this.tab_data_detail_return = response.data.data_return
              this.tab_data_detail_all_status = response.data.data_all
              this.sum_return=this.sum_on_delivery=this.sum_wait_transfer=this.sum_transfer=0;

              if(response.data.data_success)
                this.sum_transfer=response.data.data_success.map(function(i){return i.codAmount}).reduce((a, b)=> a+b,0);
              if(response.data.data_success_wait_transfer)
                this.sum_wait_transfer=response.data.data_success_wait_transfer.map(function(i){return i.codAmount}).reduce((a, b)=> a+b,0);
              if(response.data.data_onTheWay)
                this.sum_on_delivery=response.data.data_onTheWay.map(function(i){return i.codAmount}).reduce((a, b)=> a+b,0);
              if(response.data.data_return)
                this.sum_return=response.data.data_return.map(function(i){return i.codAmount}).reduce((a, b)=> a+b,0);
           

              this.dialog_detail = true
          },

          detail_changeTab (detail_tab) {
            if (detail_tab == 1){
              this.detail_tabSelect = 0
              this.headers_detail = this.headers_detail_success
            if (detail_tab == 2){
              this.detail_tabSelect = 1
              this.headers_detail = this.headers_detail_success_wait_transfer
            }
            }else if(detail_tab ==3) {
              this.detail_tabSelect = 2
              this.headers_detail = this.headers_detail_sending
            }else if(detail_tab == 4) {
              this.detail_tabSelect = 3
              this.headers_detail = this.headers_detail_return
            }
            this.detail_tab = detail_tab
          },

          SearchingClearData () {
            var nowDate = new Date()
            this.transferred_date_to = nowDate.toISOString().substr(0, 10)
            nowDate.setDate(nowDate.getDate()-7)
            this.transferred_date_from = nowDate.toISOString().substr(0, 10)

            this.sent_date_to = nowDate.toISOString().substr(0, 10)
            nowDate.setDate(nowDate.getDate()-7)
            this.sent_date_from = nowDate.toISOString().substr(0, 10)

          },

        }
    }
</script>
